// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6bf3d866","455":"124bd3cf"}[chunkId] + ".chunk.js";
};